<template>
  <div
    class="thermostatContainer"
    v-bind:class="this.getContainerBackground"
    v-if="zone.path.split('/')[zone.path.split('/').length - 1]"
  >
    <h2 class="title">
      <span class="icon clickable returnIcon" @click="goParent()">
        <i class="mdi mdi-chevron-left"></i>
      </span>
      {{ zone.name }}
    </h2>

    <knob-control
      :data="zone"
      :min="range.min"
      :max="range.max"
      type="container"
      :power="zone.power"
      v-on:toggle-mode="updateMode"
      v-on:update-temp="setTemperature"
      :value="temperature"
      :auto="mode"
      :legend="$t('thermostat.legend')"
      :disabled="!zone.power"
    ></knob-control>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ZonesTemperature from "@/mixins/zones-temperature";
import KnobControl from "@/components/shared/KnobControl.vue";
import constants from "@/config/constants";
import colors from "@/mixins/colors";

export default {
  name: "zone-container-thermostat",
  mixins: [ZonesTemperature, colors],
  components: {
    KnobControl,
  },

  data() {
    return {
      temperature: null,
      mode: null,
      firstLoad: false,
    };
  },

  props: {
    zone: Object,
    installationId: String,
  },

  async created() {
    this.mode = await this.getZoneThermostatMode({ zone: this.zone });
  },

  methods: {
    ...mapActions("zones", {
      getZoneThermostatMode: "getZoneThermostatMode",
      allDevicesHasSameTemp: "allDevicesHasSameTemp",
      setZonePower: "setPower",
      setZoneTemperature: "setTemperature",
      setZoneMode: "setMode",
    }),

    togglePower: function () {
      this.setZonePower({
        zone: this.zone,
        power: !this.zone.power,
        discardAcs: true,
      });
    },

    updateMode: function (mode) {
      this.mode = mode === constants.modes.auto;
      this.setZoneMode({ zone: this.zone, mode: mode ? "auto" : "manual" });
    },

    setTemperature: async function (temp) {
      if (!this.firstLoad) {
        const sameTemp = await this.allDevicesHasSameTemp({ zone: this.zone });
        if (!sameTemp) {
          this.temperature = null;
        }

        this.firstLoad = true;
        return;
      }

      this.setZoneTemperature({
        zone: this.zone,
        temperature: temp,
        discardAcs: true,
      });
    },

    goParent() {
      this.$router.push(
        "/installations/" + this.installationId + "/zone/" + this.zone[".key"]
      );
    },
  },
  computed: {
    range: function () {
      return {
        min: constants.ranges.thermostat["radiator"].min,
        max: constants.ranges.thermostat["radiator"].max,
      };
    },
    getContainerBackground: function () {
      if (this.zone && this.temperature)
        return this.getZoneTemperatureColorBackground(this.zone);
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.thermostatContainer {
  background-color: #d584b5;
  color: white;
  height: 100%;
}

.title {
  color: white;
}

.powerButton img {
  height: 4rem;
  cursor: pointer;
}

.clickable {
  cursor: pointer;
}

@media screen and (max-width: 1087px) {
  .zoneName {
    padding-top: 4rem;
  }
}
</style>
